import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  empresasBuyer,
  gerarExelBuyers,
  empresasBuyerPorFiltro,
} from "../../../services/http/buyerService";
import { trackPromise } from "react-promise-tracker";
import { saveAs } from "file-saver";
import { useSnackBar } from "../../../hooks/snackBar";
import FormControl from "@material-ui/core/FormControl";
import InputSearch from "../../../components/InputSearch";

import ListBuyer from "./CadastroBuyer/ListBuyer";

import "./styles.scss";

const BuyerPage = () => {
  const history = useHistory();
  const { addSnackBar } = useSnackBar();

  const [busca, setBusca] = useState("");
  const [empresaResponse, setEmpresas] = useState({
    numeroPagina: 0,
    totalPaginas: 0,
    lista: [],
    tamanhoPagina: 0,
    hasPreviousPage: false,
    hasNextPage: false,
  });

  const CarregarListaBuyers = (pagina) => {
    trackPromise(
      empresasBuyer(pagina).then((res) => {
        console.log(res.data);
        if (res.data) {
          setEmpresas(res.data);
        }
      })
    ).catch((error) => {
      console.error("Erro ao carregar lista de cadastro");
    });
  };

  const CarregarListaBuyersComFiltro = (filtro, pagina) => {
    trackPromise(
      empresasBuyerPorFiltro(filtro, pagina).then((res) => {
        if (res.data) {
          setEmpresas(res.data);
        } else {
          addSnackBar({
            message: "Não foi possível carregar buyers",
            info: "error",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ano tentar carregar buyers",
        info: "error",
        open: true,
      });
    });
  };

  const buscar = (filtro) => {
    setBusca(filtro);
  };

  const extrairBase = () => {
    trackPromise(
      gerarExelBuyers().then((res) => {
        if (res.data) {
          saveAs(res.data, "buyers.xlsx");
        } else {
          addSnackBar({
            message: "Não foi possível extrair a base com buyers",
            info: "warning",
            open: true,
          });
        }
      })
    ).catch((error) => {
      addSnackBar({
        message: "Erro ano extrair a base com buyers",
        info: "error",
        open: true,
      });
    });
  };

  const mudarPaginaBuyer = (page) => {
    busca != ""
      ? CarregarListaBuyersComFiltro(busca, page)
      : CarregarListaBuyers(page);
  };

  useEffect(() => {
    if (busca != "") {
      const delayDebounceFn = setTimeout(() => {
        CarregarListaBuyersComFiltro(busca, 1);
      }, 2000);

      return () => clearTimeout(delayDebounceFn);
    } else {
      CarregarListaBuyers(1);
    }
  }, [busca]);

  return (
    <div className="buyers-container">
      <div className="row mb-3">
        <div className="col-12">
          <h2 className="titulo">Buyers</h2>
        </div>
      </div>

      {/* Botões de ação */}
      <div className="row">
        <div className="col-sm-6 col-md-3 mb-2">
          <button
            className="button-anexar buton-green w-100"
            onClick={() => history.push(`/admin/buyer/cadastro`)}
          >
            NOVO BUYER
          </button>
        </div>
        <div className="col-sm-6 col-md-3 mb-2">
          <button
            className="buton-white-black-border btn btn-block btn-lg"
            onClick={extrairBase}
          >
            EXTRAIR BASE
          </button>
        </div>
      </div>

      {/* Campo de busca */}
      <div className="row mb-1 d-flex justify-content-end">
        <div className="col-sm-6 col-md-3">
          <FormControl>
            <InputSearch buscar={buscar} buscaPor={busca} />
          </FormControl>
        </div>
      </div>

      {/* Lista de buyers */}
      <div className="row">
        <div className="col-12">
          <ListBuyer
            data={empresaResponse}
            mudarPagina={mudarPaginaBuyer}
            buscar={buscar}
            busca={busca}
          />
        </div>
      </div>
    </div>
  );
};

export default BuyerPage;
